import { useState } from "react";

export default function Body3() {
  const options = [
    // "AI Prompt",
    "AI Prompt & Shopping Cart",
    // "Card sort",
    "Conjoint",
    "Custom Set up",
    "NPS",
    "Gabor Granger",
    "Text Highlighter and HeatMap",
    "Image and video",
    "Drag and drop",
    "Single-Select",
    "Multi-Select",
    "Rating",
    "Open-end",
  ];

  const itemsData = {
    NPS: [
      {
        title: "NPS",
        description: "Net Promoter Score",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250354?",
        imgSrc: "./nps.gif",
      },
    ],
    "Gabor Granger": [
      {
        title: "Gabor Granger",
        description:
          "Helps in inquiring & capturing final pricing for asked product/service.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250355?",
        imgSrc: "./GaborGranger.gif",
      },
    ],
    // "AI Prompt": [
    //   {
    //     title: "Prompt in textbox question",
    //     description: "Text area question with an AI prompt.",
    //     link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250327?",
    //     imgSrc: "./PromptWithTextboxQuestions.gif",
    //   },
    // ],
    "Single-Select": [
      {
        title: "Simple Radio",
        description: "Choose a single option from a list.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241268?",
        imgSrc: "./singleselect/SimpleRadio.gif",
      },
      {
        title: "Single Select Button",
        description: "Select one option using buttons.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241274?",
        imgSrc: "./singleselect/SingleselectButton.gif",
      },
      {
        title: "Single Select Grid",
        description: "Select one option per row in a grid.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241273?",
        imgSrc: "./singleselect/Singleselectgrid.gif",
      },
      {
        title: "Single Select Button Grid",
        description: "Choose a single option in a grid format.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241275?",
        imgSrc: "./singleselect/Singleselectbuttongrid.gif",
      },
      {
        title: "This or That",
        description: "Choose between two options.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241281?",
        imgSrc: "./singleselect/ThisorThat.gif",
      },
      {
        title: "Dropdown",
        description: "Choose an option from a dropdown menu.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241280?",
        imgSrc: "./singleselect/Dropdown.gif",
      },
    ],
    "AI Prompt & Shopping Cart": [
      {
        title: "Prompt in textbox question",
        description: "Text area question with an AI prompt.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250327?",
        imgSrc: "./PromptWithTextboxQuestions.gif",
      },
      {
        title: "Shopping Cart",
        description: "Select and manage items in a cart.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241292?",
        imgSrc: "./first/ShoppingCart.gif",
      },
      {
        title: "Shopping cart conjoint",
        description:
          "participants simulate purchasing items from an online store.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/240511?debug=respview&",
        imgSrc: "./ShoppingCartCojoint.gif",
      },
    ],
    Conjoint: [
      {
        title: "Maxdiff Survey",
        description: "Uses 'Best-Worst' scaling to rank preferences for items.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/240508?id=test&debug=respview&",
        imgSrc: "./MaxDiff.gif",
      },
      {
        title: "DCM normal",
        description: "Analyzes choices for pricing.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/240509?debug=respview&",
        imgSrc: "./NormalDCM.gif",
      },
      {
        title: "Complex B2B DCM",
        description: "Predicts B2B decision-making ",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/240507?debug=respview&",
        imgSrc: "./ComplexDCM.gif",
      },
    ],
    "Multi-Select": [
      {
        title: "Multi Select Grid",
        description: "Choose multiple options in a grid.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241277?",
        imgSrc: "./multiselect/MultiselectGrid.gif",
      },
      {
        title: "Multi Select",
        description: "Choose multiple options.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241276?",
        imgSrc: "./multiselect/Multiselect.gif",
      },
      {
        title: "Multi Select Button",
        description: "Select multiple options using buttons.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241278?",
        imgSrc: "./multiselect/MultiselectButton.gif",
      },
      {
        title: "Multi Select Grid Button",
        description: "Select multiple options in a grid format.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241279?",
        imgSrc: "./multiselect/MultiselectGridButton.gif",
      },
    ],
    Rating: [
      {
        title: "Single Select Rating",
        description: "Rate on a 0-10 scale.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241299?",
        imgSrc: "./rating/SingleSelectRating.gif ",
      },
      {
        title: "Single Select Rating",
        description: "Rate on a 1-5 scale.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241296?",
        imgSrc: "./rating/SingleSelectRating2.gif ",
      },
      {
        title: "Smiley Rating",
        description: "Rate using smiley faces.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241298?",
        imgSrc: "./rating/SmileyRating.gif",
      },
      {
        title: "Like-Dislike Rating",
        description: "Rate using thumbs up or down.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241297?",
        imgSrc: "./rating/LikeDislikeRating.gif",
      },
      {
        title: "Drag Rating Scale",
        description: "Rate by dragging items on a scale.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241284?",
        imgSrc: "./rating/Dragratingscale.gif",
      },
      {
        title: "Slider Rating",
        description: "Rate items by adjusting sliders.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241286?",
        imgSrc: "./rating/SliderRatingScale.gif",
      },
      {
        title: "Number slider",
        description: "Select a value using a slider.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241287?",
        imgSrc: "./rating/NumberSlider.gif",
      },

      {
        title: "Button Rating",
        description: "Rate using a button scale.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241282?",
        imgSrc: "./rating/Buttonrating.gif",
      },
      {
        title: "Star Rating",
        description: "Rate using stars.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241283?",
        imgSrc: "./rating/StarRating.gif",
      },
    ],
    "Open-end": [
      {
        title: "Numeric Box Grid",
        description: "Question trigger based on response.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241241?",
        imgSrc: "./openend/Numericbox.gif",
      },
      {
        title: "Numeric box",
        description: "Question trigger based on response.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241242?",
        imgSrc: "./openend/NumberboxGrid.gif",
      },
      {
        title: "Open end",
        description: "Question trigger based on response of 'First Box’.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241243?",
        imgSrc: "./openend/Customtextbox.gif",
      },
      {
        title: "Custom textbox",
        description: "Enter the phone number with extension.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241245?",
        imgSrc: "./openend/Openend.gif",
      },
      {
        title: "Autosuggestion Element",
        description:
          "Question type that will automatically suggests relevant response.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250353?",
        imgSrc: "./Autosuggestion.gif",
      },
      {
        title: "Open End with custom message",
        description:
          "Textbox question with custom message with color highlighting.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250356?",
        imgSrc: "./OpenEndWithCustomMessage.gif",
      },
    ],

    "Drag and drop": [
      {
        title: "Drag and Drop",
        description: "Drag items to desired locations.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241288?",
        imgSrc: "./dragdrop/Draganddrop.gif",
      },
      {
        title: "Drag and Drop Images",
        description: "image drag and drop with enlarge image property",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241254?",
        imgSrc: "./dragdrop/DragandDropImage.gif",
      },
      {
        title: "Drag and Drop Images",
        description: "image drag and drop with enlarge image property",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/240510?debug=respview&",
        imgSrc: "./dragdrop/ImageDragandDrop-ezgif.com-crop.gif",
      },
    ],
    "Image and video": [
      {
        title: "Image",
        description: "Question based on 'Time interval'.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241244?",
        imgSrc: "./imagevideo/CustomSetup9.gif",
      },

      {
        title: "Image Magnifier",
        description: "The image will zoom when hovered.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241248?",
        imgSrc: "./imagevideo/ImageMagnifier.gif",
      },
      {
        title: "Image pop-up on click",
        description: "The image will zoom when clicked.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241249?",
        imgSrc: "./imagevideo/Imagepopuponclick.gif",
      },
      {
        title: "Image on hover",
        description: "The image will appear when hovering over the text.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241250?",
        imgSrc: "./imagevideo/ImageonHover.gif",
      },
      {
        title: "Video Player",
        description: "Watch a video and respond.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241291?",
        imgSrc: "./imagevideo/VideoPlayer.gif",
      },
      {
        title: "Video rating",
        description: "Watch a video and rate.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/240830?",
        imgSrc: "./imagevideo/Videorating.gif",
      },
    ],

    "Text Highlighter and HeatMap": [
      {
        title: "Text Highlighter",
        description: "Highlighter the text which you like by hovering over it.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250100?",
        imgSrc: "./first/texthighter.gif",
      },

      {
        title: "Card Sort Multi-Select",
        description: "Sort multiple items into categories.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241290?",
        imgSrc: "./first/CardSortMultiSelect.gif",
      },

      {
        title: "Image HeatMap",
        description: "Participants highlight areas of interest on an image.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250101?",
        imgSrc: "./first/ImageHeatMap.gif",
      },

      {
        title: "Card Sort Single Select",
        description: "Sort items into categories with single selection.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241289?",
        imgSrc: "./first/CardSortSingleselect.gif",
      },

      {
        title: "Card Rating",
        description: "Rate items by selecting cards.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241285?",
        imgSrc: "./first/CardRating.gif",
      },
    ],
    "Custom Set up": [
      {
        title: "Demo Slider with Pie Chart",
        description: "Adjustable sliders with real-time pie chart feedback.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250608?",
        imgSrc: "./custom/th_demo_slider_with_pie_chart.gif",
      },
      {
        title: "Demo Hotspot",
        description: "Image-based hotspot demo with selectable regions.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250590?",
        imgSrc: "./custom/th_demo_hotspot.gif",
      },
      {
        title: "Custom Ranking",
        description: "Arrange items in order of importance or relevance.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/250455?",
        imgSrc: "./custom_ranking.gif",
      },
      {
        title: "Radio",
        description: "Trigger based on selection.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241237?",
        imgSrc: "./custom/Radio-1.gif",
      },
      {
        title: "Radio",
        description: "Open-end trigger based on selection.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241238?",
        imgSrc: "./custom/Radio-2.gif",
      },
      {
        title: "Multicheck",
        description: "Trigger subgroups dynamically on selection.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241239?",
        imgSrc: "./custom/Multicheck.gif",
      },
      {
        title: "Radio Grid",
        description:
          "Question trigger based on selction of 'Not very likely' & 'Not at all likely'.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241240?",
        imgSrc: "./custom/RadioGrid.gif",
      },
      {
        title: "Single Select",
        description:
          "Select one option with logo and description layout (1-10 scale).",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241264?",
        imgSrc: "./custom/Custom-SetupSingleselect.gif",
      },
      {
        title: "Single Select",
        description:
          "Select one option with logo and description layout (1-5 scale).",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241265?",
        imgSrc: "./custom/Custom-SetupSingleselect1-5.gif",
      },

      {
        title: "Slider with exclusive None",
        description: "Custom Slider setup with exclusive option.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241247?",
        imgSrc: "./custom/Sliderwithexclusivenone.gif",
      },
      {
        title: "Merged Question",
        description:
          "Number question grid with exclusive checkbox for each option.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241251?",
        imgSrc: "./custom/Mergedquestion-1.gif",
      },
      {
        title: "Merged Question",
        description:
          "Number question grid with exclusive checkbox for each option 2.",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241252?",
        imgSrc: "./custom/Mergedquestion-2.gif",
      },
      {
        title: "Merged Question",
        description:
          "Show option selected from the dropdown list in one column ",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241259?",
        imgSrc: "./custom/Mergedquestion-3.gif",
      },

      {
        title: "Drop down",
        description:
          "question to fix col on topmost side of the page when scrolling",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241258?",
        imgSrc: "./custom/Dropdowncustom.gif",
      },
      {
        title: "AutoSum",
        description:
          "Calculating percentage distribution in an autosum/number grid",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241260?",
        imgSrc: "./custom/Autosum.gif",
      },
      {
        title: "Number question",
        description: "exclusive checkbox and autosum enabled for each column",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241253?",
        imgSrc: "./custom/Numberquestion.gif",
      },
      {
        title: "Drop down and number",
        description:
          "Cal % distribution in an drop down merged with number question",
        link: "https://thsurveys.decipherinc.com/survey/selfserve/53b/241261?",
        imgSrc: "./custom/Dropwdownandnumber.gif",
      },
    ],
  };

  const [expandedSection, setExpandedSection] = useState(options[0]); // Default to the first section

  const toggleSection = (option) => {
    setExpandedSection((prev) => (prev === option ? null : option));
  };
  return (
    <div className="xl:px-[70px] lg:px-[50px] md:px-[30px] px-[24px] font-serif space-y-8">
      <div className="text-[32px] font-medium">Question Database</div>
      {options.map((option, index) => (
        <div key={index} className="space-y-4">
          {/* Heading Section */}
          <div
            className="w-full bg-[#31BE6C] text-white px-4 py-2 rounded-xl shadow-lg cursor-pointer flex justify-between items-center"
            onClick={() => toggleSection(option)}
            // style={{ boxShadow: "0 0px 15px rgba(46, 72, 255, 0.50)" }}
          >
            <p className="font-medium text-[16px]">{option}</p>
            <span className="text-[20px]">
              {expandedSection === option ? "▲" : "▼"}
            </span>
          </div>

          {/* Items Section */}
          {expandedSection === option && (
            <div
              className="p-10 transition-all duration-300 bg-white rounded-2xl"
              style={{ boxShadow: "0 0px 15px rgba(46, 72, 255, 0.50)" }}
            >
              <div className="flex flex-wrap justify-between gap-2 md:justify-normal md:gap-8">
                {itemsData[option]?.map((item, idx) => (
                  <div key={idx} className="">
                    <p className="text-[20px] font-medium">{item.title}</p>
                    <p className="sm:w-[200px] sm:h-[50px] text-[12px] py-2">
                      {item.description}
                    </p>
                    <div className="card sm:w-[200px] sm:h-[110px] h-[250px] rounded-3xl bg-gradient-to-b from-[#6871f0] to-[rgb(9,102,241)] p-[3px] hover:scale-105 hover:shadow-[0_5px_15px_rgba(9,102,241)] transition-transform duration-300">
                      <a
                        href={`${item.link}list=0`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.imgSrc.endsWith(".mp4") ? (
                          <video
                            className="w-full h-full object-contain rounded-[20px]"
                            src={item.imgSrc}
                            controls
                            loop
                            autoPlay
                            muted
                          />
                        ) : (
                          <img
                            className="w-full h-full object-fit rounded-[20px]"
                            src={item.imgSrc}
                            alt={item.title}
                          />
                        )}
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
